import api from './api';
import { cleanAnalyticsParams } from './executiveAnalytics';

/**
 * ТЗ V5 №11. GET /analytics/control-timeline — только чтение.
 *
 * Принимает те же period + scope + control_* параметры, что и
 * executive-summary для таблицы «Камеры и простои», поэтому строки приходят в
 * том же порядке и с той же страницей. Сегменты — абсолютные UTC-интервалы
 * (timezone_basis = absolute_utc_interval).
 */
export const getControlTimeline = (params = {}, { signal } = {}) =>
  api.get('/analytics/control-timeline', {
    params: cleanAnalyticsParams(params),
    signal,
  }).then((response) => response.data);
